import { render, staticRenderFns } from "./ListDataselection.vue?vue&type=template&id=25c58f8b&scoped=true&"
import script from "./ListDataselection.vue?vue&type=script&lang=js&"
export * from "./ListDataselection.vue?vue&type=script&lang=js&"
import style0 from "./ListDataselection.vue?vue&type=style&index=0&id=25c58f8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c58f8b",
  null
  
)

export default component.exports